import React, { Component } from 'react'
import TutorialCard from '../Components/TutorialCard'
import Navbar from '../Components/Navbar'
const title = "Contact"
const content="Dipti Prakash Sinha"
export default class Contact extends Component {
    render() {
        return (
            <>
                <header>
                    <Navbar />
                </header>
                <main className="main">
                    <TutorialCard title={title} content={content}></TutorialCard>
                </main>
            </>
        )
    }
}
